import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";

export const tooltips = () => {
	tippy("[data-tippy-content]");
};
